import { ABOUT, SITE } from '../data/site'
import { Reveal } from './Reveal'
import { Section } from './Section'
import styles from './About.module.css'

export function About() {
  return (
    <Section id="about" eyebrow="About" title="Great to meet you.">
      <div className={styles.layout}>
        <Reveal className={styles.portraitWrap}>
          <figure className={styles.figure}>
            <img
              className={styles.portrait}
              src="/Headshot.JPG"
              alt="Nick Volgas"
              width={640}
              height={800}
              loading="lazy"
              decoding="async"
            />
            <figcaption className={styles.caption}>
              {SITE.role}
              <span aria-hidden="true"> · </span>
              {SITE.employer}
            </figcaption>
          </figure>
        </Reveal>

        <Reveal className={styles.prose} delay={80}>
          {ABOUT.map((paragraph, i) => (
            <p key={i} className={i === 0 ? styles.first : undefined}>
              {paragraph}
            </p>
          ))}
        </Reveal>
      </div>
    </Section>
  )
}
